import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';


const Card = ({ header, children }) => {
  return (
    <div className={`card text-left w-100 mb-4 ${styles.card}`}>
      <If condition={header}>
        <div className={`card-header ${styles.header}`}>
          {header}
        </div>
      </If>
      <div className={`card-body ${styles.body}`}>
        {children}
      </div>
    </div>
  );
}

Card.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node
}

export default Card;


// WEBPACK FOOTER //
// src/components/shared/Card/index.jsx